import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_TABLE_EXPORT_ACTION,
} from '../../../../actions/actionTypes';

export default fetchReducerGenerator(
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_TABLE_EXPORT_ACTION
);
